import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import "./CollapsableSimpleCard.scss";
import { SyntheticEvent } from "react";

export default function CollapsableSimpleCard(props: {
  card_title?: string;
  cardTitleStyle?: string;
  children?: JSX.Element | JSX.Element[];
  goal_done?: boolean;
  step?: number;
  is_goal?: boolean;
  LeftComponent?: JSX.Element;
  RightComponent?: JSX.Element;
  onChange?: (event: SyntheticEvent<Element, Event>, expanded: boolean) => void;
  onClick?: (event: SyntheticEvent<Element, Event>) => void;
  key?: string;
}) {
  const { key, card_title, cardTitleStyle, onChange, onClick } = props;
  return (
    <div key={key} className="flex-shrink-0 collapsable_card">
      <Accordion onChange={onChange} onClick={onClick}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          {props.LeftComponent && <>{props.LeftComponent}</>}
          {props.is_goal && <div className="step_number">{props.step}</div>}
          {card_title && (
            <Typography className={`accordion_title ${cardTitleStyle}`}>
              {card_title}
            </Typography>
          )}
          {props.is_goal && (
            <div className="goal_attained">
              {props.goal_done ? (
                <></>
              ) : (
                <img
                  src={require("assets/progress circle.svg").default}
                  alt=""
                  className="icon"
                />
              )}
            </div>
          )}
          {props.RightComponent && <>{props.RightComponent}</>}
        </AccordionSummary>
        <AccordionDetails>{props.children}</AccordionDetails>
      </Accordion>
    </div>
  );
}
